(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Wholesale Sidebar functionality
  class WholesaleSidebar {
    constructor() {
      this.sidebar = document.getElementById('wholesale-sidebar');
      this.closeButton = this.sidebar?.querySelector('.wholesale-sidebar__close');
      this.overlay = this.sidebar?.querySelector('.wholesale-sidebar__overlay');
      
      this.init();
    }

    init() {
      if (!this.sidebar) return;

      // Add click event to wholesale links
      this.addWholesaleLinkListeners();
      
      // Add close functionality
      this.closeButton?.addEventListener('click', () => this.close());
      this.overlay?.addEventListener('click', () => this.close());
      
      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.sidebar.classList.contains('active')) {
          this.close();
        }
      });

      // Prevent body scroll when sidebar is open
      this.sidebar.addEventListener('transitionend', () => {
        if (this.sidebar.classList.contains('active')) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      });
    }

    addWholesaleLinkListeners() {
      console.log('Setting up wholesale sidebar listeners...');
      
      // Method 1: Find all navigation links and check for "wholesale" text
      const allNavLinks = document.querySelectorAll('.header__menu-item, .menu-drawer__menu-item');
      console.log('Found nav links:', allNavLinks.length);
      
      allNavLinks.forEach((link, index) => {
        console.log(`Link ${index}:`, link.textContent.trim());
        // Check if the link text contains "wholesale" (case insensitive)
        if (link.textContent.toLowerCase().trim().includes('wholesale')) {
          console.log('Found wholesale link:', link.textContent.trim());
          link.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.open();
          });
        }
      });

      // Method 2: Also check all links in the header area as a fallback
      const headerLinks = document.querySelectorAll('header a');
      console.log('Found header links:', headerLinks.length);
      
      headerLinks.forEach((link, index) => {
        console.log(`Header link ${index}:`, link.textContent.trim());
        if (link.textContent.toLowerCase().trim().includes('wholesale')) {
          console.log('Found wholesale header link:', link.textContent.trim());
          link.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.open();
          });
        }
      });

      // Method 3: Use event delegation for dynamic content
      document.addEventListener('click', (e) => {
        const target = e.target.closest('a');
        if (target && target.textContent.toLowerCase().trim().includes('wholesale')) {
          console.log('Wholesale link clicked via delegation:', target.textContent.trim());
          e.preventDefault();
          e.stopPropagation();
          this.open();
        }
      });

      // Method 4: Global click handler as ultimate fallback
      document.addEventListener('click', (e) => {
        // Check if clicked element or its parent is a link with "wholesale" text
        let element = e.target;
        while (element && element !== document.body) {
          if (element.tagName === 'A' && element.textContent.toLowerCase().trim().includes('wholesale')) {
            console.log('Wholesale link clicked via global handler:', element.textContent.trim());
            e.preventDefault();
            e.stopPropagation();
            this.open();
            return;
          }
          element = element.parentElement;
        }
      });
    }

    open() {
      if (this.sidebar) {
        // Set a very high z-index to ensure it's above everything
        this.sidebar.style.zIndex = '999999';
        
        // Add class to body to hide elements
        document.body.classList.add('wholesale-sidebar-open');
        
        // Hide any elements that might be above the sidebar
        this.hideElementsAboveSidebar();
        
        // Show overlay immediately
        this.overlay.style.opacity = '1';
        this.overlay.style.visibility = 'visible';
        
        this.sidebar.classList.add('active');
        
        // Focus the close button for accessibility
        setTimeout(() => {
          this.closeButton?.focus();
        }, 300);
      }
    }

    hideElementsAboveSidebar() {
      // Find and hide elements that might appear above the sidebar
      const elementsToHide = [
        '.shopify-section-group-header-group', // Announcement bar
        '.announcement-bar-section',
        '.utility-bar',
        '.header-wrapper',
        '.header'
      ];

      elementsToHide.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          if (element) {
            element.style.zIndex = '1';
            element.style.position = 'relative';
          }
        });
      });
    }

    close() {
      if (this.sidebar) {
        this.sidebar.classList.remove('active');
        document.body.style.overflow = '';
        document.body.classList.remove('wholesale-sidebar-open');
        
        // Hide overlay
        this.overlay.style.opacity = '0';
        this.overlay.style.visibility = 'hidden';
        
        // Restore original z-index values
        this.restoreOriginalZIndex();
      }
    }

    restoreOriginalZIndex() {
      // Restore original z-index values for elements
      const elementsToRestore = [
        '.shopify-section-group-header-group',
        '.announcement-bar-section', 
        '.utility-bar',
        '.header-wrapper',
        '.header'
      ];

      elementsToRestore.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          if (element) {
            element.style.zIndex = '';
            element.style.position = '';
          }
        });
      });
    }
  }

  // Initialize the wholesale sidebar when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    new WholesaleSidebar();
    initFloatingLabels();
  });

  // Also initialize after a short delay to catch any dynamically loaded content
  setTimeout(() => {
    if (!window.wholesaleSidebar) {
      window.wholesaleSidebar = new WholesaleSidebar();
    }
    initFloatingLabels();
  }, 1000);

  // Initialize floating labels
  function initFloatingLabels() {
    const inputGroups = document.querySelectorAll('.wholesale-sidebar__input-group');
    
    inputGroups.forEach(group => {
      const input = group.querySelector('input');
      const label = group.querySelector('label');
      
      if (input && label) {
        // Don't auto-float labels on page load, even if they have values
        // Only float when user actually interacts with the field
        
        // Handle focus events
        input.addEventListener('focus', () => {
          label.classList.add('floating');
        });
        
        // Handle blur events
        input.addEventListener('blur', () => {
          if (!input.value || input.value.trim() === '') {
            label.classList.remove('floating');
          }
        });
        
        // Handle input events
        input.addEventListener('input', () => {
          if (input.value && input.value.trim() !== '') {
            label.classList.add('floating');
          } else {
            label.classList.remove('floating');
          }
        });
      }
    });
  }

  // Form validation
  class WholesaleFormValidator {
    constructor() {
      this.form = document.querySelector('.wholesale-sidebar__form-fields');
      this.submitBtn = document.getElementById('wholesale-submit');
      this.hasBeenSubmitted = false; // Track if form has been submitted
      this.init();
    }

    init() {
      if (!this.form || !this.submitBtn) return;

      this.submitBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hasBeenSubmitted = true; // Mark that form has been submitted
        this.validateForm();
      });

      // Real-time validation on input (only after first submit)
      this.addRealTimeValidation();
    }

    addRealTimeValidation() {
      const inputs = this.form.querySelectorAll('input, textarea');
      inputs.forEach(input => {
        input.addEventListener('blur', () => {
          // Only validate on blur if form has been submitted
          if (this.hasBeenSubmitted) {
            this.validateField(input);
          }
        });
        input.addEventListener('input', () => {
          // Only do real-time validation if form has been submitted
          if (this.hasBeenSubmitted) {
            this.handleRealTimeValidation(input);
          }
        });
        input.addEventListener('focus', () => {
          // Only do real-time validation if form has been submitted
          if (this.hasBeenSubmitted) {
            this.handleRealTimeValidation(input);
          }
        });
      });

      // Add real-time validation for checkboxes
      this.addCheckboxRealTimeValidation();
    }

    addCheckboxRealTimeValidation() {
      const checkboxGroups = ['sell-location', 'stock-quantity', 'hear-about'];
      
      checkboxGroups.forEach(groupName => {
        const checkboxes = document.querySelectorAll(`input[name="${groupName}"]`);
        checkboxes.forEach(checkbox => {
          checkbox.addEventListener('change', () => {
            // Only do real-time validation if form has been submitted
            if (this.hasBeenSubmitted) {
              this.handleCheckboxGroupValidation(groupName);
            }
          });
        });
      });
    }

    handleRealTimeValidation(input) {
      // Clear error immediately when user starts typing or focusing
      this.clearFieldError(input);
      
      // If field becomes empty after having content, validate it
      if (!input.value || input.value.trim() === '') {
        if (input.hasAttribute('required')) {
          // Small delay to allow for complete clearing
          setTimeout(() => {
            if (!input.value || input.value.trim() === '') {
              this.validateField(input);
            }
          }, 150);
        }
      } else {
        // If field has content, validate it immediately to catch format errors
        if (input.type === 'email' || input.type === 'tel' || input.type === 'url' || input.id === 'country-code') {
          this.validateField(input);
        }
      }
    }

    handleCheckboxGroupValidation(groupName) {
      const checkboxes = document.querySelectorAll(`input[name="${groupName}"]:checked`);
      
      // Clear existing error for this group immediately when user interacts
      this.clearQuestionError(groupName);

      // If no checkboxes are selected, show error after a short delay
      if (checkboxes.length === 0) {
        setTimeout(() => {
          const currentCheckboxes = document.querySelectorAll(`input[name="${groupName}"]:checked`);
          if (currentCheckboxes.length === 0) {
            const questionNames = {
              'sell-location': 'Where do you intend to sell Paani?',
              'stock-quantity': 'Quantity of stock required?',
              'hear-about': 'How did you hear about Paani?'
            };
            this.showQuestionError(groupName, `Please select at least one option for: ${questionNames[groupName]}`);
          }
        }, 100);
      }
    }

    validateForm() {
      let isValid = true;
      const errors = [];

      // Clear previous errors
      this.clearAllErrors();

      // Required text fields
      const requiredFields = [
        { id: 'first-name', name: 'First name' },
        { id: 'last-name', name: 'Last name' },
        { id: 'company-name', name: 'Company name' },
        { id: 'country-code', name: 'Country code' },
        { id: 'telephone', name: 'Telephone number' },
        { id: 'email', name: 'Email address' },
        { id: 'country', name: 'Country' }
      ];

      requiredFields.forEach(field => {
        const input = document.getElementById(field.id);
        if (!input || !input.value.trim()) {
          this.showFieldError(input, `${field.name} is required`);
          isValid = false;
          errors.push(`${field.name} is required`);
        } else if (field.id === 'email' && !this.isValidEmail(input.value)) {
          this.showFieldError(input, 'Please enter a valid email address');
          isValid = false;
          errors.push('Please enter a valid email address');
        } else if (field.id === 'telephone' && !this.isValidPhone(input.value)) {
          this.showFieldError(input, 'Please enter a valid phone number');
          isValid = false;
          errors.push('Please enter a valid phone number');
        } else if (field.id === 'country-code' && !this.isValidCountryCode(input.value)) {
          this.showFieldError(input, 'Please enter a valid country code (e.g., +1, +44, +91)');
          isValid = false;
          errors.push('Please enter a valid country code');
        }
      });

      // Check at least one option is selected for each question
      const questionGroups = [
        { name: 'sell-location', question: 'Where do you intend to sell Paani?' },
        { name: 'stock-quantity', question: 'Quantity of stock required?' },
        { name: 'hear-about', question: 'How did you hear about Paani?' }
      ];

      questionGroups.forEach(group => {
        const checkboxes = document.querySelectorAll(`input[name="${group.name}"]:checked`);
        if (checkboxes.length === 0) {
          this.showQuestionError(group.name, `Please select at least one option for: ${group.question}`);
          isValid = false;
          errors.push(`Please select at least one option for: ${group.question}`);
        }
      });

      // Show error summary if validation fails
      if (!isValid) {
        this.showErrorSummary(errors);
        this.submitBtn.disabled = false;
      } else {
        // Clear any existing error summary before submitting
        const existingSummary = document.querySelector('.wholesale-sidebar__error-summary');
        if (existingSummary) {
          existingSummary.remove();
        }
        this.submitForm();
      }
    }

    validateField(input) {
      const fieldName = input.getAttribute('name') || input.getAttribute('id');
      const value = input.value.trim();

      if (input.hasAttribute('required') && !value) {
        this.showFieldError(input, `${this.getFieldDisplayName(fieldName)} is required`);
        return false;
      }

      if (input.type === 'email' && value && !this.isValidEmail(value)) {
        this.showFieldError(input, 'Please enter a valid email address');
        return false;
      }

      if (input.type === 'tel' && value && !this.isValidPhone(value)) {
        this.showFieldError(input, 'Please enter a valid phone number');
        return false;
      }

      if (input.id === 'country-code' && value && !this.isValidCountryCode(value)) {
        this.showFieldError(input, 'Please enter a valid country code (e.g., +1, +44, +91)');
        return false;
      }

      if (input.type === 'url' && value && !this.isValidUrl(value)) {
        this.showFieldError(input, 'Please enter a valid URL');
        return false;
      }

      return true;
    }

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }

    isValidPhone(phone) {
      const phoneRegex = /^[\+]?[0-9\s\-\(\)]{10,}$/;
      return phoneRegex.test(phone);
    }

    isValidCountryCode(code) {
      // Country code should start with + and have 1-4 digits
      const countryCodeRegex = /^\+[1-9]\d{0,3}$/;
      return countryCodeRegex.test(code);
    }

    isValidUrl(url) {
      try {
        new URL(url);
        return true;
      } catch {
        return false;
      }
    }

    getFieldDisplayName(fieldName) {
      const displayNames = {
        'first-name': 'First name',
        'last-name': 'Last name',
        'company-name': 'Company name',
        'country-code': 'Country code',
        'telephone': 'Telephone number',
        'email': 'Email address',
        'country': 'Country',
        'website': 'Website',
        'linkedin': 'LinkedIn',
        'instagram': 'Instagram',
        'facebook': 'Facebook',
        'twitter': 'Twitter',
        'additional-info': 'Additional information'
      };
      return displayNames[fieldName] || fieldName;
    }

    showFieldError(input, message) {
      input.classList.add('wholesale-sidebar__field-error');
      
      // Remove existing error message
      const existingError = input.parentNode.querySelector('.wholesale-sidebar__error-message');
      if (existingError) {
        existingError.remove();
      }

      // Add new error message
      const errorDiv = document.createElement('div');
      errorDiv.className = 'wholesale-sidebar__error-message show';
      errorDiv.textContent = message;
      input.parentNode.appendChild(errorDiv);

      // Keep label floating even when there are errors - don't reset to default position
      const label = input.parentNode.querySelector('label');
      if (label) {
        // Always keep the label floating when there's an error, regardless of input value
        label.classList.add('floating');
      }
    }

    showQuestionError(questionName, message) {
      const questionContainer = document.querySelector(`input[name="${questionName}"]`).closest('.wholesale-sidebar__question');
      if (questionContainer) {
        const existingError = questionContainer.querySelector('.wholesale-sidebar__error-message');
        if (existingError) {
          existingError.remove();
        }

        const errorDiv = document.createElement('div');
        errorDiv.className = 'wholesale-sidebar__error-message show';
        errorDiv.textContent = message;
        questionContainer.appendChild(errorDiv);
      }
    }

    clearQuestionError(questionName) {
      const questionContainer = document.querySelector(`input[name="${questionName}"]`).closest('.wholesale-sidebar__question');
      if (questionContainer) {
        const existingError = questionContainer.querySelector('.wholesale-sidebar__error-message');
        if (existingError) {
          existingError.remove();
        }
      }
    }

    clearFieldError(input) {
      input.classList.remove('wholesale-sidebar__field-error');
      const errorMessage = input.parentNode.querySelector('.wholesale-sidebar__error-message');
      if (errorMessage) {
        errorMessage.remove();
      }

      // Ensure floating label behavior is correct based on input value
      const label = input.parentNode.querySelector('label');
      if (label) {
        if (input.value && input.value.trim() !== '') {
          label.classList.add('floating');
        } else {
          label.classList.remove('floating');
        }
      }
    }

    clearAllErrors() {
      // Clear field errors
      const errorFields = document.querySelectorAll('.wholesale-sidebar__field-error');
      errorFields.forEach(field => {
        field.classList.remove('wholesale-sidebar__field-error');
      });

      // Clear error messages
      const errorMessages = document.querySelectorAll('.wholesale-sidebar__error-message');
      errorMessages.forEach(message => {
        message.remove();
      });

      // Clear error summary
      const errorSummary = document.querySelector('.wholesale-sidebar__error-summary');
      if (errorSummary) {
        errorSummary.remove();
      }

      // Reset floating labels to correct state
      const inputGroups = document.querySelectorAll('.wholesale-sidebar__input-group');
      inputGroups.forEach(group => {
        const input = group.querySelector('input');
        const label = group.querySelector('label');
        if (input && label) {
          if (input.value && input.value.trim() !== '') {
            label.classList.add('floating');
          } else {
            label.classList.remove('floating');
          }
        }
      });
    }

    showErrorSummary(errors) {
      // Show error summary at the top of the form
      const existingSummary = document.querySelector('.wholesale-sidebar__error-summary');
      if (existingSummary) {
        existingSummary.remove();
      }

      const errorSummary = document.createElement('div');
      errorSummary.className = 'wholesale-sidebar__error-summary';
      errorSummary.innerHTML = `
        <div style="background-color: #fef2f2; border: 1px solid #fecaca; border-radius: 6px; padding: 16px; margin-bottom: 20px;">
          <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 12px;">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9" stroke="#DC2626" stroke-width="2"/>
              <path d="M10 6V10M10 14H10.01" stroke="#DC2626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span style="color: #dc2626; font-weight: 600; font-size: 16px; line-height: 1;">Please fix the following errors to proceed:</span>
          </div>
          <ul style="margin: 0; padding-left: 20px; color: #dc2626;">
            ${errors.map(error => `<li>${error}</li>`).join('')}
          </ul>
        </div>
      `;

      this.form.insertBefore(errorSummary, this.form.firstChild);
    }

    submitForm() {
      this.submitBtn.disabled = true;
      this.submitBtn.textContent = 'Submitting...';

      // Clear all errors immediately when form is successfully submitted
      this.clearAllErrors();

      // Collect form data
      const formData = this.collectFormData();

      // Simulate form submission (replace with actual submission logic)
      setTimeout(() => {
        console.log('Form submitted with data:', formData);
        alert('Thank you for your submission! We will get back to you soon.');
        this.resetForm();
        this.submitBtn.disabled = false;
        this.submitBtn.textContent = 'Submit';
      }, 2000);
    }

    collectFormData() {
      const formData = {};

      // Text fields
      const textFields = this.form.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], input[type="url"], textarea');
      textFields.forEach(field => {
        if (field.value.trim()) {
          formData[field.name || field.id] = field.value.trim();
        }
      });

      // Checkboxes
      const checkboxGroups = ['sell-location', 'stock-quantity', 'hear-about'];
      checkboxGroups.forEach(groupName => {
        const checkedBoxes = document.querySelectorAll(`input[name="${groupName}"]:checked`);
        formData[groupName] = Array.from(checkedBoxes).map(cb => cb.value);
      });

      return formData;
    }

    resetForm() {
      this.form.reset();
      this.clearAllErrors();
      this.hasBeenSubmitted = false; // Reset submission state
      
      // Reset floating labels
      const inputGroups = document.querySelectorAll('.wholesale-sidebar__input-group');
      inputGroups.forEach(group => {
        const input = group.querySelector('input');
        const label = group.querySelector('label');
        if (input && label) {
          label.classList.remove('floating');
        }
      });
    }
  }

  // Initialize form validator
  document.addEventListener('DOMContentLoaded', () => {
    new WholesaleFormValidator();
  });

  } catch(e) { console.error(e); }
})();
})();
